import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import { ANNUAL, MONTHLY } from '../../constans';
import { formatDate, formatMoney } from '../../utils/Formatter';
import { addDaysToDate } from '../../utils/Date';
import CheckBox from '../../components/CheckBox';
import Footer from '../../components/Footer';
import { useSessionCheck } from '../../hooks/useSessionCheck';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { BACKEND_URL } from '../../services/contants';
import { getCurrentUser } from '../../services/auth';
import { useAppContext } from '../../store/AppContext';


export default function PlanChangeConfirmation() {
  //useSessionCheck()
  const { state } = useAppContext()
  const user = state.user
  const plan = sessionStorage.getItem("plan");
  const [readAgreements, setReadAgreements] = useState(false)
  const [understood, setUnderstood] = useState(false)
  const planData = [{ title: MONTHLY, value: 4.99 }, { title: ANNUAL, value: 49 }]
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    if (loading) return
    setLoading(true)
    const token = await getCurrentUser().getIdToken(true);
    const res = await fetch(`${BACKEND_URL}/${user.subscription.provider}/switch-plan`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        plan: plan
      })
    });
    const result = await res.json()
    if (result.success)
      navigate("/plan_change_complete")
    setLoading(false)
  };

  function getPlanData() {
    return planData.filter((data) => data.title == plan)[0]
  }

  function trans(key, options) {
    return t("onb-web_subscribeplanconfirmation_" + key, options)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header />
      <div className={"scrollContainer mt-32"} style={style.scrollContainer}>
        <div style={style.subtitle}>{trans(69, { period: t(plan) })}</div>
        <p className={"description body_15_regular mt-16"}>
          {trans(70, { period: plan, mode: t("performance") })}
        </p>
        <p className='body_15_regular mt-12' style={style.subtag}>
          {trans(71)}
        </p>
        <p className='body_15_regular mt-12' style={style.subtag}>
          {trans(72)}
        </p>
        <p className='body_15_regular mt-12' style={style.subtag}>
          {trans(73)}
        </p>
        <p className='body_15_regular mt-12' style={style.subtag}>
          {trans(74)}
        </p>
        <p className='body_15_regular mt-12' style={style.subtag}>
          {trans(75)}
        </p>
        <p className='body_15_regular mt-12' style={style.subtag}>
          {trans(76)}
        </p>
        <div className='divider mt-24' />

        <div style={style.subsubtile} className='mt-24'>
          {trans(77, { amount: t(`onb-web_subscribeplan_${plan == MONTHLY ? 61 : 65}`) })}
        </div>
        <div style={style.subsubtile} className='mt-8'>
          {trans(78, { date: formatDate(addDaysToDate(new Date(), 30)) })}
        </div>
        <p className='body_14_regular mt-16' style={style.subtag}>
          {trans(79)}
        </p>
        <div className='divider mt-24' />
        <CheckBox
          className='mt-24'
          label={
            <span className="mt-16 body_15_regular">
              <span style={{ color: colors.error }}
                className='body_15_regular'>* </span>
              <Trans i18nKey={"payment_confirmation_125"}>
                저는 Eyeary
                <a style={style.link} target="_blank" rel="noopener noreferrer" href="/tos"> 이용약관</a>
                과
                <a style={style.link} target="_blank" rel="noopener noreferrer" href="/privacy_policy"> 개인정보처리방침</a>
                에 동의합니다.
              </Trans>
            </span>}
          checked={readAgreements}
          onPress={() => setReadAgreements(!readAgreements)}
        />
        <CheckBox
          className='mt-24'
          label={<span>
            <span style={{ color: colors.error }}
              className='body_15_regular'>* </span>
            {trans(80)}
          </span>}
          checked={understood}
          onPress={() => setUnderstood(!understood)}
        />

        <div className='divider' style={{ marginTop: 150 }} />
        <Footer />
      </div>
      <div className="button-wrapper">
        <Button
          text={t('confirm')}
          onClick={handleConfirm}
          disabled={!understood || loading}
          className={(understood && !loading ? "primary-on-button" : "primary-off-button") + " primary-button-text"}
        />
      </div>

    </ScreenContainer>

  );
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll'
  },
  subsubtile: {
    ...typography.body['15_regular'],
    color: '#fff',
    width: '100%'
  },
  price: {
    ...typography.headline['16_regular']
  },
  freeTrial: {
    color: colors.mono300
  },
  note: {
    ...typography.body['15_regular'],
    color: colors.primaryColor100
  },
  subtitle: {
    ...typography.title.s_18_medium,
    color: colors.white,
    width: '100%',
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
  },
  subtag: {
    color: colors.mono300,

    width: '100%'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 18px'

  },
  contentTitle: {
    ...typography.body["15_medium"],
    color: '#fff',
    textAlign: 'center'
  },
  contentDescription: {
    ...typography.body["15_regular"],
    color: colors.mono300,
    marginTop: 6,
    textAlign: 'center'
  },
  link: {
    textDecoration: 'underline'
  }
}